module.exports = __webpack_public_path__ + "img/ttf.45b4b425.svg";